import React, { useEffect, useRef } from 'react';

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

export default function KanbanCard({
  card,
  isDragging,
  dragHandleProps,
  innerRef,
  draggableProps,
  style,
  onCardClick,
}) {
  const didDragRef = useRef(false);

  useEffect(() => {
    if (isDragging) {
      didDragRef.current = true;
    }
  }, [isDragging]);

  const assigneeLabel = card.assignedUserName || 'Unassigned';
  const priorityLabel = card.priorityName || 'No Priority';

  const { onMouseDown: dragOnMouseDown, ...restDragHandleProps } = dragHandleProps || {};

  const handleMouseDown = (e) => {
    didDragRef.current = false;
    dragOnMouseDown?.(e);
  };

  const handleClick = () => {
    if (didDragRef.current || isDragging) {
      didDragRef.current = false;
      return;
    }
    onCardClick?.(card);
  };

  return (
    <div
      ref={innerRef}
      {...draggableProps}
      {...restDragHandleProps}
      style={style}
      className={`kanban-card-item${isDragging ? ' dragging' : ''}`}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      <div className="kanban-card-title" title={card.cardTitle}>
      {card.cardTitle}
      </div>

      <div className="kanban-card-meta-row mt-2">
        <div className="kanban-card-tags">
          <span className="kanban-tag kanban-tag-assignee" style={{height: 'fit-content'}}>{assigneeLabel}</span>
          <span className="kanban-card-avatar" title={assigneeLabel}>
          <i className="fas fa-user" />
        </span>
        </div>
      </div>
      <div className="kanban-card-tags kanban-card-priority-row mt-2">
      {(card.dueDate || card.createdAt) && (
        <div className="kanban-card-date">{formatDate(card.dueDate || card.createdAt)}</div>
      )}
        <span className="kanban-tag kanban-tag-priority">{priorityLabel}</span>
      </div>
    </div>
  );
}
